var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.953 29.2071V16.5942L2.92754 10.218V22.543C2.92754 22.6283 2.94879 22.7083 2.99129 22.783C3.03407 22.858 3.09824 22.9221 3.18379 22.9755L13.953 29.2071ZM16.0471 29.2071L26.8163 22.9755C26.9018 22.9221 26.966 22.858 27.0088 22.783C27.0513 22.7083 27.0725 22.6283 27.0725 22.543V10.2009L16.0471 16.5896V29.2071ZM15 14.8121L25.8838 8.49172L15.2563 2.34297C15.171 2.29659 15.0856 2.27339 15 2.27339C14.9145 2.27339 14.8291 2.29659 14.7438 2.34297L4.09921 8.49172L15 14.8121ZM2.13671 24.7992C1.72199 24.5592 1.40101 24.2388 1.17379 23.838C0.946846 23.4374 0.833374 23.0049 0.833374 22.5405V9.45964C0.833374 8.9952 0.946846 8.5627 1.17379 8.16214C1.40101 7.76131 1.72199 7.44089 2.13671 7.20089L13.6967 0.533391C14.1131 0.301169 14.5491 0.185059 15.0046 0.185059C15.4602 0.185059 15.8931 0.301169 16.3034 0.533391L27.8634 7.20089C28.2781 7.44089 28.5991 7.76131 28.8263 8.16214C29.0532 8.5627 29.1667 8.9952 29.1667 9.45964V22.5405C29.1667 23.0049 29.0532 23.4374 28.8263 23.838C28.5991 24.2388 28.2781 24.5592 27.8634 24.7992L16.3034 31.4667C15.887 31.6989 15.451 31.8151 14.9955 31.8151C14.5399 31.8151 14.107 31.6989 13.6967 31.4667L2.13671 24.7992Z",
    fill: "#F05A29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon);
export default __webpack_public_path__ + "static/media/box-icon.d2e46449f3a8e863aad0ed13c8798da8.svg";
export { ForwardRef as ReactComponent };